import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  private months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  transform(value: any, ...args: any[]): any {
    let format = args[0];
    if (value == null) {
      return null;
    }
    //Handle PHP DateTime objects
    if (typeof value == "object" && value.hasOwnProperty("date")) {
      value = value.date;
    }
    let date = new Date(value);
    //Handle non-dates
    if (isNaN(date.getTime())) {
      return null;
    }
    switch (format) {
      case 'FjY':
        return this.months[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
        break;
      default:
        return date.toLocaleString();
        break;
    }
    return null;
  }

}
